/** TRACS Voucher ID used for draft vouchers that have never been submitted to TRACS. */
export const DEFAULT_TRACS_VOUCHER_ID = '9999999';

/** Mirrors the backend `tracsVoucherIdSchema`: numeric, up to 10 digits. */
export const TRACS_VOUCHER_ID_PATTERN = /^\d{1,10}$/;

/** Voucher submission statuses that lock a HUD cert from being edited/reopened. */
export const LOCKED_VOUCHER_SUBMISSION_STATUSES = ['Approved', 'Paid'];

/** HUD voucher submission status values. */
export const VOUCHER_SUBMISSION_STATUS = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  ERROR: 'Error',
  PAID: 'Paid',
};
